module.exports = __webpack_public_path__ + "static/assets/029f2533163e160cd39075be03c3db73.png";